<template>
  <button
    class="button-toggle"
    :data-off="!isVisibleAuxiliaryDisplayControl"
    @click="onClickToggle"
  >
    <ToggleSwitch
      :modelValue="isVisibleAuxiliaryDisplayControl"
      @update:model-value="onClickToggle"
    />
    {{ t('auxiliary_display_remote_control') }}
  </button>
</template>

<script setup lang="ts">
import { inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ToggleSwitch from '@/components/shared/composite/ToggleSwitch.vue';
import {
  ij_isVisibleAuxiliaryDisplayControl,
  ij_openAuxiliaryDisplayControl,
  ij_closeAuxiliaryDisplayControl,
} from '@/utils/injectionKeys';

const { t } = useI18n();

const isVisibleAuxiliaryDisplayControl = inject<Ref<boolean>>(
  ij_isVisibleAuxiliaryDisplayControl
);
const openAuxiliaryDisplayControl = inject(
  ij_openAuxiliaryDisplayControl,
  () => {}
);
const closeAuxiliaryDisplayControl = inject(
  ij_closeAuxiliaryDisplayControl,
  () => {}
);

const onClickToggle = () => {
  if (isVisibleAuxiliaryDisplayControl?.value) {
    closeAuxiliaryDisplayControl();
  } else {
    openAuxiliaryDisplayControl();
  }
};
</script>

<style scoped lang="scss"></style>
